export type BlockedType = "cancelled" | "branch_disabled" | "store_suspended" | "unregistered";

const CONFIG: Record<BlockedType, { title: string; message: string; icon: string }> = {
  cancelled: {
    title: "تم إلغاء حسابك",
    message: "تم إلغاء حسابك — تواصل مع صاحب المحل",
    icon: "ri-user-forbid-line",
  },
  unregistered: {
    title: "رقم غير مسجّل كموظف",
    message: "هذا الرقم غير مسجّل كموظف في المحل — تواصل مع صاحب المحل لإضافتك",
    icon: "ri-user-unfollow-line",
  },
  branch_disabled: {
    title: "الفرع معطّل",
    message: "الفرع معطّل حاليًا — تواصل مع صاحب المحل",
    icon: "ri-store-2-line",
  },
  store_suspended: {
    title: "المحل معلّق",
    message: "المحل معلّق من الإدارة — تواصل مع صاحب المحل",
    icon: "ri-forbid-2-line",
  },
};

interface BlockedNoticeProps {
  type: BlockedType;
  onBack: () => void;
}

export default function BlockedNotice({ type, onBack }: BlockedNoticeProps) {
  const info = CONFIG[type];

  return (
    <div className="text-center animate-scale-in">
      <div className="w-16 h-16 mx-auto rounded-full bg-red-50 flex items-center justify-center">
        <i className={`${info.icon} text-3xl text-red-500`}></i>
      </div>
      <h2 className="mt-5 text-lg font-bold text-foreground-900 flex items-center justify-center gap-2">
        <i className="ri-alert-line text-accent-600"></i>
        {info.title}
      </h2>
      <p className="mt-2 text-sm text-foreground-500 leading-relaxed">{info.message}</p>

      <div className="mt-6 p-3 rounded-btn bg-background-100 text-xs text-foreground-500 flex items-start gap-2 text-right leading-relaxed">
        <i className="ri-information-line text-base mt-0.5 shrink-0"></i>
        <span>لا يمكن المتابعة من هنا. يرجى التواصل مباشرة مع صاحب المحل لحل المشكلة.</span>
      </div>

      <button
        type="button"
        onClick={onBack}
        className="mt-5 text-sm font-semibold text-primary-600 hover:text-primary-700 cursor-pointer inline-flex items-center gap-1.5"
      >
        <i className="ri-arrow-right-line"></i>
        رجوع إلى تسجيل الدخول
      </button>
    </div>
  );
}